// © 2015-2021 WDNA - All Rights Reserved

import CustomerTypes from './loaders/CustomerTypes';
import Commands from './loaders/Commands';
import ModuleTypes from './loaders/ModuleTypes';
import ResultTypes from './loaders/ResultTypes';
import SensorTypes from './loaders/SensorTypes';
import Parameters from './loaders/Parameters';
import Variables from './loaders/Variables';

export const redirects: any[] = [
  {
    from: '/configuration',
    to: '/configuration/parameters',
  },
];

export const routes: any[] = [
  {
    component: Commands,
    path: '/configuration/commands',
  },
  {
    component: CustomerTypes,
    path: '/configuration/customerTypes',
  },
  {
    component: ModuleTypes,
    path: '/configuration/moduleTypes',
  },
  {
    component: ResultTypes,
    path: '/configuration/resultTypes',
  },
  {
    component: SensorTypes,
    path: '/configuration/sensorTypes',
  },
  {
    component: Parameters,
    path: '/configuration/parameters',
  },
  {
    component: Variables,
    path: '/sensors/variables',
  },
];
